import { getSelectedProduct } from 'axp-product-ducks';
import { getProcedureResult } from 'iguazu-rpc';
import { READ_CUSTOMER_PRODUCTS_V2_FUNCTION, ROUTES } from '../constants';
import { getDefaultProduct } from './getDefaultProduct';

const redirectToAccountDetails =
  (store) => async (nextState, replace, callback) => {
    let selectedProduct = await getSelectedProduct(store.getState());
    if (selectedProduct === undefined) {
      const productsResult = getProcedureResult({
        procedureName: READ_CUSTOMER_PRODUCTS_V2_FUNCTION,
        args: {
          timeout: 6e3,
        },
      })(store.getState());
      selectedProduct = getDefaultProduct(productsResult).opaqueAccountId;
    }
    replace(
      ROUTES.ACCOUNTS_DETAILS.replace(
        ':id',
        encodeURIComponent(selectedProduct)
      )
    );
    callback();
  };

export default redirectToAccountDetails;
